import { CognitoUserPool, CognitoUserAttribute, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import {handleNewSession, authError, handleNewCredentials} from './actions/auth';

const poolData = {
  UserPoolId : 'us-east-1_wX2HD6UYa', // Your user pool id here
  ClientId : '78dc74vs98bnoieubshq047nud' // Your client id here
};

const userPool = new CognitoUserPool(poolData);
var cognitoUser = null;
var userAttributes = null;
var _dispatch = null;

let checkSession = () => {
  // console.log('checkSession', cognitoUser);
  window.cognitoUser = cognitoUser;
  if (cognitoUser && cognitoUser.signInUserSession && !cognitoUser.signInUserSession.isValid()) {
    cognitoUser.getSession((e, credentials) => {
      if (e) {
        _dispatch(authError(e))
      } else {
        _dispatch(handleNewCredentials(credentials.idToken.jwtToken));
      }
    })
  }
}

export default {
  pool: userPool,
  cognitoUser: cognitoUser,
  userAttributes: userAttributes,
  init: (dispatch) => {
    _dispatch = dispatch;
    let user = userPool.getCurrentUser();
    if (user) {
      cognitoUser = user;
      user.getSession((e, session) => {
        window.session = session;
        window.user = user;
        if (e) {
          dispatch(authError(e))
        } else {
          user.getSession((e, credentials) => {
            if (e) {
              dispatch(authError(e))
            } else {
              user.getUserAttributes((e, attrs) => {
                console.log('attrs', attrs);
                if (e) {
                  dispatch(authError(e))
                } else {
                  userAttributes = attrs;
                  attrs = attrs.reduce((memo, a) => {memo[a.Name] = a.Value; return memo}, {});
                  dispatch(handleNewSession(attrs.name, attrs.email, attrs["custom:organization"], credentials.idToken.jwtToken, attrs["custom:tos"]));
                }
              });
            }
          });
        }
      });
    }
    setInterval(checkSession, 1000);
  },
  authenticate: (email, password, callback, newPasswordCallback) => {
    cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool
    });
    let authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password
    });
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => callback(null, result),
      onFailure: (err) => callback(err),
      newPasswordRequired: (attrs, requiredAttributes) => {
        userAttributes = attrs;
        newPasswordCallback(attrs, requiredAttributes);
      }
    });
  },
  completeNewPasswordChallenge: (password, callback) => {
    cognitoUser.completeNewPasswordChallenge(password, {...userAttributes, email_verified: null}, {
      onSuccess: (result) => { callback(null, result) },
      onFailure: callback
    })
  },
  getUserAttributes: (callback) => {
    cognitoUser.getUserAttributes(callback);
  },
  registerUser: (attrs, callback) => {
    let attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: attrs.email
      })
    ];
    if (attrs.name) {
      attributeList.push(new CognitoUserAttribute({
        Name: 'name',
        Value: attrs.name
      }))
    }
    if (attrs.organization) {
      attributeList.push(new CognitoUserAttribute({
        Name: 'custom:organization',
        Value: attrs.organization
      }))
    }
    attributeList.push(new CognitoUserAttribute({
      Name: 'custom:tos',
      Value: 'signed'
    }));
    attributeList.push(new CognitoUserAttribute({
      Name: 'custom:country',
      Value: attrs.country
    }));
    attributeList.push(new CognitoUserAttribute({
      Name: 'custom:organizationType',
      Value: attrs.organizationType
    }));

    userPool.signUp(attrs.email, attrs.password, attributeList, null, function(err, result){
      if (err) {
        callback(err);
      } else {
        cognitoUser = result.user;
        callback(null, result);
      }
    });
  },
  forgotPassword: (email, callback) => {
    cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool
    });
    cognitoUser.forgotPassword({
      onSuccess: function () {
          // successfully initiated reset password request
          callback()
      },
      onFailure: function(err) {
          callback(err);
      },
      //Optional automatic callback
      // inputVerificationCode: function(data) {
      //     console.log('Code sent to: ' + data);
      //     var verificationCode = prompt('Please input verification code ' ,'');
      //     var newPassword = prompt('Enter new password ' ,'');
      //     cognitoUser.confirmPassword(verificationCode, newPassword, this);
      // }
    });
  },
  confirmPassword: (code, password, callback) => {
    cognitoUser.confirmPassword(code, password, {
      onFailure: (err) => {
        callback(err);
      },
      onSuccess: () => {
        callback(null);
      }
    })
  },
  signOut: () => {
    cognitoUser.signOut();
    cognitoUser = null;
  }
}
